module.exports = __webpack_public_path__ + "static/img/363.1af14f97.png";